var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_4661)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37_4661",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.34058e-05H17.9999V18H0V5.34058e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37_4661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66794 3.4102H1.93359C1.15692 3.4102 0.527344 4.03978 0.527344 4.81645V16.0664C0.527344 16.8431 1.15692 17.4727 1.93359 17.4727H13.1836C13.9602 17.4727 14.5898 16.8431 14.5898 16.0664V8.33206",
    stroke: "#252525",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.267 2.72173L9.3121 10.6766L6.82617 11.1738L7.32335 8.6879L15.2783 0.732981C15.5528 0.458411 15.9981 0.458411 16.2726 0.732981L17.267 1.72737C17.5416 2.00194 17.5416 2.44712 17.267 2.72173Z",
    stroke: "#252525",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2832 1.72808L16.2719 3.7168",
    stroke: "#252525",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_4661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.d4e63872f2b24e84920c3ce5de44ef38.svg";
export { ForwardRef as ReactComponent };